const LabourAndEmploymentdata = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Shram Yogi Maan-Dhan (PM-SYM)",
        discription:"Pradhan Mantri Shram Yogi Maan-dhan is a social welfare scheme launched by the Ministry of Labour and Employment of the Government of India in February 2019 for poor labourers in the unorganized sector from minimum 18 years of age to maximum 40 years.",
        launchDate: "February 2019",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Pradhan Mantri Rojgar Protsahan Yojana (PMRPY)",
    discription:"The Pradhan Mantri Rojgar Protsahan Yojana (PMRPY) is a scheme to incentivise employers registered with the Employees' Provident Fund Organization (EPFO) for job creation, by virtue of the Government of India paying the full contribution of employers to the Employee Pension Scheme (EPS) and Employees' Provident Fund (EPF) in respect of new employees having a new Universal Account Number (UAN). ",
    launchDate: "August 2016",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "EPFO – Provisional Monthly Estimate of Payroll",
    discription:"None",
    launchDate: "write",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "National Career Service [NCS portal]",
        discription:"The Ministry is implementing the National Career Service (NCS) Project as a Mission Mode Project for transformation of the National Employment Service to provide a variety of employment related services like career counseling, vocational guidance, information on skill development courses, apprenticeship, internships etc.",
        launchDate: "20 July 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Shram Suvidha Portal ",
    discription:"The Unified Shram Suvidha Portal introduced on 16th October 2014 was developed to make it easier to report inspections and submission of returns. The portal is a single platform of contact between employer, employee and enforcement agencies.",
    launchDate: "16 October 2014", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "ESIC-SPREE-A",
    discription:"ESIC-SPREE-A ‘Scheme for Promoting Registration of Employers and Employees (SPREE)’ introduced",
    launchDate: "write",
    AnualFund: "12345"
},

]

export default LabourAndEmploymentdata;
